/**
 * Programs a user can coordinate, in a fixed priority order.
 *
 * Matches the server's own scan order (server/src/api/course/
 * course.controller.js's `['si', 'ta', 'la'].find(...)`). A user holding
 * more than one coordinator role at once must resolve to the same program
 * everywhere — every page that needs "which program does this coordinator
 * belong to" reads it from here, rather than re-deriving it (e.g. by
 * scanning `roles` in array-insertion order, which can disagree with this
 * fixed order and therefore with the server, depending on how a given
 * account's roles happen to have been added over time).
 */
export const COORDINATOR_PROGRAMS = ['si', 'ta', 'la'];

/**
 * The `<program>_coordinator` role name for each entry in
 * COORDINATOR_PROGRAMS, e.g. 'si' -> 'si_coordinator'.
 *
 * @param {string[] | null | undefined} roles
 * @returns {string | undefined} e.g. 'si_coordinator', or undefined if the
 *   user holds no coordinator role.
 */
export function getCoordinatorRole(roles) {
    return COORDINATOR_PROGRAMS.map((program) => `${program}_coordinator`).find(
        (role) => roles?.includes(role)
    );
}

/**
 * The program a user coordinates ('si' | 'ta' | 'la'), or undefined.
 *
 * @param {string[] | null | undefined} roles
 * @returns {string | undefined}
 */
export function getCoordinatorProgram(roles) {
    const coordinatorRole = getCoordinatorRole(roles);
    return coordinatorRole?.replace('_coordinator', '');
}
